<template>
  <div class="wrap">
    <van-nav-bar :title="$t('page.aboutus')">
      <van-icon slot="left" name="arrow-left" color="#fff" @click="$router.back()" />
    </van-nav-bar>
    <div class="content" v-html="content"></div>
  </div>
</template>

<script>
import { NavBar, Icon, Toast } from "vant";
import { $post } from "../../utils/request";
export default {
  components: { [NavBar.name]: NavBar, [Icon.name]: Icon },
  data() {
    return {
      content: "",
    };
  },
  created() {
    this.getContent();
  },
  methods: {
    async getContent() {
      Toast.loading();
      try {
        const res = await $post("/other/config", { act: "about" });
        const { ret, msg, data } = res.data;
        Toast.clear();
        if (ret === 1) {
          this.content = data.about;
          return
        }
        Toast(msg)
      } catch (error) {
        Toast.clear();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.wrap {
  // background: #fff;
}

.content {
  padding: calc(14rem / 16);
  font-size: calc(14rem / 16);
  /deep/ a {
    word-break: break-all;
  }

  color: var(--sizeColor);
}

/deep/ img {
  width: 100%;
  height: 100%;
}
</style>